import { render } from "./uploadClients.vue?vue&type=template&id=b9aa851e&scoped=true"
import script from "./uploadClients.vue?vue&type=script&lang=js"
export * from "./uploadClients.vue?vue&type=script&lang=js"

import "./uploadClients.vue?vue&type=style&index=0&id=b9aa851e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9aa851e"]])

export default __exports__